<template>
  <div>
    <q-form ref="form">
      <div class="row justify-center items-center">
        <div class="col-5">
          <q-select
            class="q-mb-md"
            v-model="formData.articles_id"
            :options="articlesList"
            label="Tag Articles that are in Sustainability"
            map-options
            emit-value
            option-label="title"
            option-value="id"
            :disable="formData.url ? true : false"
          >
          </q-select>
        </div>
        <div class="col-2 text-center">
          <span class="text-bold"> OR </span>
        </div>
        <div class="col-5">
          <q-input
            :disable="formData.articles_id ? true : false"
            v-model="formData.url"
            label="Tag outside Articles as URL"
          >
          </q-input>
        </div>
      </div>

      <q-btn
        v-if="isCreate"
        color="primary"
        @click="create"
        class="float-right q-mt-sm"
        :disable="disable"
      >
        <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
        <span class="sustainability-font q-mx-sm" style="font-size: 13px">
          Add
        </span>
      </q-btn>
      <q-btn
        v-else
        color="primary"
        @click="save"
        class="float-right q-mt-sm"
        :disable="disable"
      >
        <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
        <span class="sustainability-font q-mx-sm" style="font-size: 13px">
          Save
        </span>
      </q-btn>
    </q-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      data: "solutions/articles/selectedArticle",
      articlesList: "articles/list",
    }),
  },
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    formData: {},
    isCreate: true,
  }),
  watch: {
    $route: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.$store.dispatch("articles/loadAll");
      if (this.$route.params.hasOwnProperty("articlesID")) {
        await this.$store.dispatch(
          "solutions/articles/loadArticleByID",
          this.$route.params.articlesID
        );

        this.formData = JSON.parse(JSON.stringify(this.data));
        this.isCreate = false;
      }
    },
    async create() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        let result = await this.$store.dispatch("solutions/articles/new", {
          ...this.formData,
          solutions_id: this.$route.params.id,
        });

        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });

          this.formData = {
            url: "",
            articles_id: null,
          };
          await this.$refs.form.reset();
          this.closeForm();
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      }
    },
    async save() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        let result = await this.$store.dispatch("solutions/articles/save", {
          ...this.formData,
          solutions_id: this.$route.params.id,
        });
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          this.actionFormData = {
            url: "",
            articles_id: null,
          };
          await this.$refs.form.reset();
          this.closeForm();
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      }
    },
    closeForm() {
      this.$emit("closeForm");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
